import p7_img1 from '../Assets/p7_img1.webp'
import p8_img1 from '../Assets/p8_img1.webp'
import p9_img1 from '../Assets/p9_img1.webp'
import p10_img1 from '../Assets/p10_img1.jpeg'

let data_product= [
    {
        id: 7,
        name: "Premium Cotton Shirt with Classic Collar and Slim Fit",
        image: p7_img1,
        new_price: 4200.00,
        old_price: 5000.00,
        star: 4,
        reviews: 60,
      },
      {
        id: 8,
        name: "Boys Cotton Kurta with Button Detailing and Comfortable Fit",
        image: p8_img1,
        new_price: 2600.00,
        old_price: 3200.00,
        star: 3,
        reviews: 45,
      },
      {
        id: 9,
        name: "Georgette Saree with Embroidered Motifs and Sheer Pallu",
        image: p9_img1,
        new_price: 9500.00,
        old_price: 11200.00,
        star: 5,
        reviews: 70,
    },
      {
        id: 10,
        name: "Handcrafted Beaded Necklace with Adjustable Closure and Vibrant Accents",
        image: p10_img1,
        new_price: 1750.00,
        old_price: 2100.00,
        star: 4,
        reviews: 35,
    }
]
export default data_product